export default [
    {
        back: 'customer_id',
        front: 'customerID',
    },
    {
        back: 'sucursal_id',
        front: 'sucursalID',
    },
    {
        back: 'pos_sale_type',
        front: 'posSaleType',
    },
    {
        back: 'globa_discount',
        front: 'globalDiscount',
    },
    {
        back: 'sale_detail',
        front: 'saleDetail',
    },
]
